// extracted by mini-css-extract-plugin
export default {"root":"styles_root__mWCJU","body":"styles_body__AUYfd","footer":"styles_footer__0jqcU"};